import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ResourceSigner,
  UploadDAO,
} from '../../../../core/services/dao/uploadDAO';
import { Subscription } from 'rxjs';
import { CropperSettings, ImageCropperComponent } from 'ngx-img-cropper';
import { dataURLtoFile } from '../../../../core/pure-functions/upload/image-upload-helper';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { AuthService } from '../../../../core/services/auth.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-upload-single-photo',
  templateUrl: './upload-single-photo.component.html',
  styleUrls: ['./upload-single-photo.component.scss'],
})
export class UploadSinglePhotoComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input()
  previewOnly: boolean;

  @Input()
  filenamePrefix: string;

  @Input()
  actionButtonText: string;

  @Input()
  cropperSettings: CropperSettings;

  @Input()
  resourceSigner: ResourceSigner;

  @Input()
  resourceSignerForeignKey: number | string;

  @Input()
  resourceSignerResourceKey: string;

  @Input()
  currentPhotoUrl: string;

  @Input()
  isAdmin: boolean;

  @Input()
  aspectRatio: number;

  @Input()
  maintainAspectRatio: boolean;

  @Output() onCancelled = new EventEmitter<boolean>();
  @Output() onSubmitted = new EventEmitter<UploadRequest>();

  @ViewChild('cropper')
  cropper: ImageCropperComponent;

  fileToUpload: Blob = null;
  subs: Subscription[] = [];
  signedPhotoUrl: string;
  croppedData: any;
  showCropper = false;
  maxWidthHeightConstant = 900;
  minWidthHeightConstant = 300;
  canvas = 400;

  imageChangedEvent: any = '';
  croppedUploadedImage: any = '';
  rotation = 0;

  constructor(private uploadDAO: UploadDAO, private authService: AuthService) {
    this.croppedData = {};
  }
  ngOnInit() {
    this.setPreviewerFromSigned();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedUploadedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
    if (!this.croppedUploadedImage) {
      this.showCropper = true;
    }
  }

  updatePhoto() {
    this.fileToUpload = this.getCroppedFile();
    this.showCropper = false;
    this.onSubmitted.emit({
      fileInput: this.fileToUpload,
      filename: this.filenamePrefix,
    });
  }

  getCroppedFile(): Blob {
    const croppedFileB64 = this.croppedUploadedImage;
    return dataURLtoFile(croppedFileB64, this.filenamePrefix);
  }

  handleFileInput($event) {
    this.fileToUpload = $event.target.files[0];
    this.readUrl();
  }

  readUrl() {
    if (this.fileToUpload) {
      const image: any = new Image();
      const reader: FileReader = new FileReader();
      reader.onloadend = (event: any) => {
        console.log('reader.onloadend');
        image.src = event.target.result;
        image.onload = () => {
          console.log('image loaded');
          this.showCropper = true;
        };
      };
      reader.readAsDataURL(this.fileToUpload);
    }
  }

  private setPreviewerFromSigned(): void {
    if (
      this.resourceSignerResourceKey &&
      this.resourceSignerForeignKey &&
      this.resourceSigner
    ) {
      if (this.isAdmin) {
        const resourceSignerSub = this.resourceSigner
          .adminGetSignedResource(
            this.resourceSignerForeignKey,
            this.resourceSignerResourceKey,
          )
          .subscribe((signedResource) => {
            this.signedPhotoUrl = signedResource.signedRequest;
          });
        this.subs.push(resourceSignerSub);
      } else {
        const resourceSignerSub = this.resourceSigner
          .getSignedResource(
            this.resourceSignerForeignKey,
            this.resourceSignerResourceKey,
          )
          .subscribe((signedResource) => {
            this.signedPhotoUrl = signedResource.signedRequest;
          });
        this.subs.push(resourceSignerSub);
      }
    }
    if (!this.resourceSigner && this.currentPhotoUrl) {
      this.signedPhotoUrl = this.currentPhotoUrl;
    }
  }

  rotateImage(direction: string) {
    if (direction === 'left') {
      this.rotation -= 1;
    } else {
      this.rotation += 1;
    }
  }
}

export interface SecureUploadResponse {
  filepath: string;
  relativePath: string;
}

export interface UploadRequest {
  fileInput: any;
  filename: string;
}
